import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';
import { useSupabase } from '../contexts/SupabaseContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useSupabase();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="xl" color="teal.500">Loading...</Text>
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login with return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // TODO: Check user state (USER_STATE_INITIAL) and show approval message if needed
  // For now, if authenticated, allow access
  return <>{children}</>;
}

